import { COMMERCIAL_DOMAINS } from "./commercialProjectSchema";

function readConstructionFromRow(row) {
  const j = row?.acf_groups_json;
  if (!j || typeof j !== "object") return {};
  return (
    j[COMMERCIAL_DOMAINS.CONSTRUCTION] ??
    j.construction_details ??
    j["Construction Details"] ??
    {}
  );
}

function isUsableContractorName(value) {
  const name = value != null ? String(value).trim() : "";
  if (!name) return false;
  return name.toLowerCase() !== "pending award";
}

/** Unique contractor names from construction / fiber fields (project ACF + optional contract overlay). */
export function contractorNamesFromConstructionFields(cons) {
  const names = [];
  const add = (value) => {
    if (!isUsableContractorName(value)) return;
    const name = String(value).trim();
    if (!names.some((n) => n.toLowerCase() === name.toLowerCase())) {
      names.push(name);
    }
  };
  add(cons?.construction_contractor ?? cons?.contractor);
  add(cons?.fiber_contractor ?? cons?.contractor_fiber);
  return names;
}

export function getProjectContractorOptions(projectRow, contractFields = null) {
  if (!projectRow) return [];
  const cons = {
    ...readConstructionFromRow(projectRow),
    ...(contractFields && typeof contractFields === "object" ? contractFields : {}),
  };
  return contractorNamesFromConstructionFields(cons);
}

export function mergeContractorOptionLists(...lists) {
  const merged = [];
  for (const list of lists) {
    for (const value of Array.isArray(list) ? list : []) {
      if (!isUsableContractorName(value)) continue;
      const name = String(value).trim();
      if (!merged.some((n) => n.toLowerCase() === name.toLowerCase())) {
        merged.push(name);
      }
    }
  }
  return merged.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
}
